import React from 'react';
import { CognocracyHero } from '../../components/cognocracy/CognocracyHero';
import { CognocracyFoundation } from '../../components/cognocracy/CognocracyFoundation';
import { CognocracyCredential } from '../../components/cognocracy/CognocracyCredential';
import { CognocracyGovernance } from '../../components/cognocracy/CognocracyGovernance';
import { RelatedInitiative } from '../../components/initiatives/RelatedInitiative';
export function CognocracyPage() {
  return <>
      <CognocracyHero data-id="element-3273" data-mp="12c26lstgyij7" />
      <CognocracyFoundation data-id="element-3274" data-mp="12ctv6jonffzz" />
      <CognocracyCredential data-id="element-3275" data-mp="12dn67wun4rnx" />
      <RelatedInitiative label="Supporting Research" name="Papers & Publications" body="White papers, assessment methods, and research directions related to Cognocracy’s proposed model." href="/roadmap#publications" linkLabel="View papers" data-id="element-3276" data-mp="12a7nmk1rd0hr" />
      <CognocracyGovernance data-id="element-3277" data-mp="oiknua8lx9u8" />
    </>;
}